import React from 'react'
import { i18nContext as context } from './context';

const useInternationalization = () => {
  const {
    translate,
    translateMicrosite,
    translation,
    language
  } = React.useContext(context);
  return {
    translate,
    translateMicrosite,
    translation,
    language
  };
}

export { useInternationalization }
